import { React } from 'Imports';
import { AlertTypes } from '$Utilities/Enums/AlertTypes';
import { ConfirmDialog } from './ConfirmDialog';
import { VideoEventService } from '$State/VideoEventFreezerService';
import * as scssStyles from '../../css/settings.scss';
import { useAppSnackbar } from '$Utilities/hooks/useAppSnackbar';
import { useEffect } from 'react';

interface IDismissConfirmationProps {
    eventIds?: number[];
    showDeletePopup: boolean;
    toggleDeletePopup: (selectedId?: number) => void;
    changeToDisabled: (disabled: boolean) => void;
    refreshVideoEvent?: () => void;
    onDismissVideo?: (eventId: number | undefined) => void;
    isBulk?: boolean;
}

export const DismissConfirmation = (props: IDismissConfirmationProps) => {
    const { eventIds = [], showDeletePopup, toggleDeletePopup, refreshVideoEvent } = props;
    const { showSnackbarMessage, handleCloseSnackbar } = useAppSnackbar();

    const isEncompass = scssStyles.styleEnvironment === 'encompass';
    const isAlert = isEncompass;
    const acceptButton = isEncompass ? 'Yes, Dismiss' : 'Dismiss';
    const cancelButton = isEncompass ? 'No, Go back' : 'Cancel';
    const showIcon = isEncompass;
    const contentMessage = `Are you sure you want to dismiss this video event?`;

    const handleToggleDeletePopup = (e: any) => {
        e.stopPropagation();

        if (toggleDeletePopup) toggleDeletePopup();
    };

    useEffect(() => {
        return () => {
            handleCloseSnackbar();
        };
    }, []);

    const handleSubmit = async (e: any): Promise<void> => {
        e.stopPropagation();
        const ev: number = eventIds[0];

        try {
            await VideoEventService.dismissVideoEvent(ev, 'Dismissed');
            showSnackbarMessage({
                message: `Event(s) dismissed successfully`,
                alertType: AlertTypes.Success,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });

            setTimeout(() => {
                if (refreshVideoEvent) {
                    refreshVideoEvent();
                }
            }, 2000);
        } catch {
            showSnackbarMessage({
                message: 'Unable to dismiss event(s).',
                alertType: AlertTypes.Fail,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
        }

        if (toggleDeletePopup) toggleDeletePopup();
    };

    const defineTitle = () => (isEncompass ? `Dismiss Video Event?` : 'Confirm Dismiss');

    return (
        <>
            <ConfirmDialog
                isOpen={showDeletePopup}
                title={defineTitle()}
                contentMessage={contentMessage}
                cancelButton={cancelButton}
                acceptButton={acceptButton}
                isAlert={isAlert}
                alertType={AlertTypes.Alert}
                showIcon={showIcon}
                handleModalClosed={(e) => handleToggleDeletePopup(e)}
                handleSubmit={(e) => handleSubmit(e)}
                isButtonAlert={false}
            />
        </>
    );
};
